import { Button, Form, Input, Modal, Row } from 'antd'
import './AddTimeActionTemplateModal.style.less'
import { useEffect } from 'react'
import { isEmptyValue } from '@/utils/common'
import { useMutation } from 'react-query'
import { queryClient } from '@/config/react-query'
import { updateTemplate } from '../../../template.transform'

interface Props {
  visible: boolean
  onClose: () => void
  data: any
}

function AddTimeActionTemplatesModal(props: Props) {
  const [form] = Form.useForm()

  const updateMutation = useMutation(async (data: any) => {
    await updateTemplate({ id: props.data.id, ...data })
  })

  const onSave = async (values) => {
    const data = {
      name: values.name,
    }
    if (!isEmptyValue(props.data)) {
      await updateMutation.mutateAsync(data)
    } else {
    }
    await queryClient.refetchQueries(['GET_TIME_ACTION_TEMPLATES'])
    props.onClose()
  }

  useEffect(() => {
    if (!isEmptyValue(props.data)) {
      form.setFieldsValue({
        name: props.data.name,
      })
    }
  }, [props.data])

  return (
    <Modal
      className="modal-add-supplier-container"
      open={props.visible}
      width={480}
      footer={false}
      maskClosable={false}
      onCancel={props.onClose}
    >
      <div>
        <p className="title">
          {!isEmptyValue(props.data) ? 'Edit' : 'New'} Time Action Templates
        </p>
        <Form labelCol={{ span: 7 }} onFinish={onSave} form={form}>
          <Form.Item
            label="Name"
            name="name"
            rules={[{ required: true, message: 'This field is required' }]}
          >
            <Input size="large" placeholder="Text" />
          </Form.Item>

          <Row className="button-container">
            <Button onClick={props.onClose} size="large">
              Cancel
            </Button>
            <Button size="large" type="primary" htmlType="submit">
              {!isEmptyValue(props.data) ? 'Save' : 'Create'}
            </Button>
          </Row>
        </Form>
      </div>
    </Modal>
  )
}

export default AddTimeActionTemplatesModal
